import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  mixins: [mixFormatoEstructura],
  data() {
    return {
      dato: '',
    };
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto, false, true);
    },
    formatoWordPlaneacion(datosPlaneacion) {
      let tipo = '';
      if (!datosPlaneacion || typeof (datosPlaneacion) !== 'object') return {};
      const planeacionMap = new Map();
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(datosPlaneacion)) {
        switch (key) {
          case 'ejercicio':
            if (!value) {
              break;
            }
            planeacionMap.set('ejercicio', `${value}`);
            break;
          case 'etapa':
            if (!value) {
              break;
            }
            planeacionMap.set('etapa', `${value}`);
            break;
          case 'clave':
            if (!value) {
              break;
            }
            planeacionMap.set('claveObra', `${value}`);
            break;
          case 'meta':
            if (!value) {
              break;
            }
            planeacionMap.set('metaObra', `${value}`);
            break;
          case 'tipo':
            if (!value) {
              break;
            }
            tipo = value.descripcion;
            planeacionMap.set('tipo', `${tipo}`);
            break;
          case 'subtipo':
            if (!value) {
              break;
            }
            tipo = value.descripcion;
            planeacionMap.set('subtipo', `${tipo}`);
            break;
          default:
            if (!value && value !== 0) {
              planeacionMap.set(key, '');
              break;
            }
            planeacionMap.set(key, value);
            break;
        }
      }
      return this.formatoObjeto(Object.fromEntries(planeacionMap));
    },
  },
};
